import { useState } from "react";
import useCartSuggestions from "@/hooks/useCartSuggestions";
import ProductCard from "@/components/ProductCard"
import SwiperComponent from "@/components/ui/swiper-component";

const HomeProductsSliderSkeleton = () => (
	<div className="container overflow-hidden">
		<div className="py-2 lg:py-4 w-full relative">

			{/* Shimmer Overlay */}
			<div
				className="absolute inset-0 z-10 pointer-events-none"
				style={{
					animation: "shimmer 3s infinite ease-in-out",
					backgroundImage: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.4) 50%, transparent 100%)",
					backgroundSize: "200% 100%",
				}}
			></div>

			{/* Header Skeleton */}
			<div className="flex items-center justify-between mb-2 lg:mb-4">
				<div className="h-6 w-32 lg:w-48 bg-jmt-neutral-100 rounded"></div>
				<div className="h-5 w-20 lg:w-24 bg-jmt-neutral-100 rounded"></div>
			</div>

			{/* Cards Slider Skeleton */}
			<div className="flex gap-2 lg:gap-4 overflow-hidden">
				{[...Array(6)].map((_, i) => (
					<div
						key={i}
						className="flex-none w-[40%] sm:w-[30%] md:w-[calc(100%/5.5-13px)]"
					>
						<div className="h-[330px] lg:h-[382px] bg-jmt-neutral-100 rounded-md w-full"></div>
					</div>
				))}
			</div>
		</div>
	</div>
);

const FrequentlyBoughtTogether = ({ className, limit = 10, topSeparator = false }) => {

	const [loading, setLoading] = useState(true);

	const { suggestion_products } = useCartSuggestions();

	if (loading && !suggestion_products) return <HomeProductsSliderSkeleton />

	return (
		suggestion_products?.length > 0 &&
		<div className={className || ''}>
			{/* جداکننده فقط وقتی رندر می‌شود که اسلایدر واقعا محصولی داشته باشد */}
			{topSeparator && <div className="block lg:hidden w-full h-0.5 bg-jmt-neutral-200 mb-4" />}
			<h3 className="text-base lg:text-xl text-jmt-main font-bold mb-2 lg:mb-4"> خریداران این محصولات، محصولات زیر را هم خریده‌اند </h3>
			<SwiperComponent
                            slides_shadow_space
				slides={suggestion_products.slice(0, limit).map((product, index) => (
					<div
						key={`product--key${product.id}`}
						className="h-full bg-white border border-jmt-neutral-200  hover-shadow-full-light rounded-md overflow-hidden"	>
						<ProductCard
							product={product} index={index}
						/>
					</div>
				))}
				swiper_className="product-slider [&>.swiper-wrapper>.swiper-slide]:!h-auto"
				slidesPerView={4}
				loop={true}
				navigation={true}
				effect="slide"
				grabCursor={true}
				breakpoints={{
					320: { slidesPerView: 1.4 },
					375: { slidesPerView: 1.5 },
					425: { slidesPerView: 1.8 },
					480: { slidesPerView: 2.1 },
					576: { slidesPerView: 2.5 },
					640: { slidesPerView: 3.1 },
					768: { slidesPerView: 3.5 },
					1024: { slidesPerView: 4.4 },
					1280: { slidesPerView: 5.4 },
					1440: { slidesPerView: 5.5 },
				}}
			/>
		</div>
	)
}
export default FrequentlyBoughtTogether
